module.exports = __webpack_public_path__ + "media/images/Interior White Door and Trim-a9a1be5b.webp";